import React from "react";
class CreateRepairRequest extends React.Component {
componentDidMount(){
    window.location.replace("https://partners.britex.cz/newdocno");
}

    render() {
        return (<></>)
    }
}

export default CreateRepairRequest;